module.exports = __webpack_public_path__ + "static/img/w01_2.868bfc9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/items/akvarium-uveg/w01_2.jpg
// module id = 535
// module chunks = 0